import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import NavigationItem from 'components_new/molecules/NavigationItem'

import { useMetric } from 'redux/hooks/Metrics'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useTranslation } from 'language/translator'

interface MetricNavigationProps {
  id: string
  sx?: SxProps
}

const MetricNavigation = (props: MetricNavigationProps) => {
  const { id, sx } = props
  const { t } = useTranslation()

  const metric = useMetric(id, null)
  const { isAdmin } = useAccountSettings()
  const disabled = !metric || !isAdmin

  return (
    <>
      <Box sx={sx}>
        <NavigationItem
          item={{
            activePattern: `/metrics/${id}`,
            href: `/metrics/${id}`,
            icon: { name: 'Image' },
            title: t('global', 'overview')
          }}
        />
        <NavigationItem
          item={{
            activePattern: `/metrics/${id}/settings*`,
            disabled: disabled,
            href: `/metrics/${id}/settings`,
            icon: { name: 'Settings' },
            title: t('global', 'settings')
          }}
        />
      </Box>
    </>
  )
}

export default MetricNavigation
